"use client";

import type { Locale } from "next-intl";
import { useMobile } from "@/lib/hooks/use-mobile";
import { cn } from "@/lib/utils";

export const HeroCircle = ({
  circleVariant,
  locale,
}: {
  circleVariant?: "default" | "higher";
  locale?: Locale;
}) => {
  const { isMobileExtended } = useMobile();

  if (locale && locale === "cz") {
    return (
      <div className="absolute top-0 left-0 h-full w-full overflow-hidden bg-brand-green2-300">
        <div className="container relative z-11 h-full w-full">
          {isMobileExtended && (
            <div
              className={cn(
                "absolute z-0 h-[682px] w-[682px] rounded-full bg-secondary",
                "top-[200px] -right-[600px]",
                "xl:top-[228px] xl:-right-[125px]",
                circleVariant === "higher" && "-top-[26px] xl:top-[120px]",
              )}
            />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="absolute top-0 left-0 h-full w-full overflow-hidden bg-brand-green2-300">
      <div className="container relative z-11 h-full w-full">
        <div
          className={cn(
            "absolute z-0 h-[682px] w-[682px] rounded-full bg-secondary",
            "top-[200px] -right-[600px]",
            "xl:top-[228px] xl:-right-[125px]",
            circleVariant === "higher" && "-top-[26px] xl:top-[120px]",
          )}
        />
      </div>
    </div>
  );
};
